import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSeven = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M10.7278 16.8C10.7854 15.7152 10.9006 14.7456 11.0734 13.8912C11.2462 13.0272 11.5102 12.2064 11.8654 11.4288C12.2206 10.6512 12.691 9.8544 13.2766 9.0384H8.9422V7.6416H15.091V8.6496C14.5534 9.312 14.1166 9.9456 13.7806 10.5504C13.4542 11.1552 13.195 11.7696 13.003 12.3936C12.8206 13.008 12.6862 13.6752 12.5998 14.3952C12.5134 15.1056 12.451 15.9072 12.4126 16.8H10.7278Z",
		fill: "currentcolor"
	})]
});
export default SvgSeven;
